export default "__VITE_ASSET__Cy25JUOL__"